// extracted by mini-css-extract-plugin
export default {"tripsIcon":"brand-global-nav-action-trips-Trips__tripsIcon--25Wn0","label":"brand-global-nav-action-trips-Trips__label--1YhSm"};